import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
// ngrx store
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// model
import { AppState } from '../../../booking/models/app-state.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrustPilotComponent } from '../trust-pilot/trust-pilot.component';
@Component({
  selector: 'app-translation-loader',
  standalone: true,
  imports: [CommonModule, FormsModule, TrustPilotComponent],
  templateUrl: './translation-loader.component.html',
  styleUrls: ['./translation-loader.component.scss']
})
export class TranslationLoaderComponent implements OnInit, OnDestroy {

  private _copyInitSubscription: Subscription;

  public showAppLoader = true;


  constructor(
    private _appStore: Store<AppState>,

    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {

    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        if (res.copyLoaded && res.rulesCopyLoaded) {
          this.showAppLoader = false;
        }
      });
  }

  ngOnDestroy() {
    if (this._copyInitSubscription) { this._copyInitSubscription.unsubscribe(); }
  }

}
